import React, { useState, useRef } from "react";
import urlicon from "../../../assets/images/function_page_icons/url.svg";
import { BsCircleFill, BsThreeDotsVertical } from "react-icons/bs";
// import classes from "../../../assets/styles/PageComponentsStyles/Function/ShowCustomURLSFunctions.module.css";
import DataTable, { createTheme } from "react-data-table-component";
import Overlay from "react-bootstrap/Overlay";
import Tooltip from "react-bootstrap/Tooltip";
import html2canvas from "html2canvas";
import { useAtom } from "jotai";
import { mobileViewCheck } from "../../../utils/store";
import ShareModal from "../../Modals/ShareModal";
import QRCodeModal from "../../Modals/QRCodeModal";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { trackEvent } from "../../../utils/mixpanel";
import Share from "../../../assets/images/global_icons/share.svg";
import Qrcode from "../../../assets/images/global_icons/qr-code.svg";
import Delete from "../../../assets/images/global_icons/delete.svg";
import Edit from "../../../assets/images/global_icons/edit.svg";
import { AiOutlineEye } from "react-icons/ai";


const ShowMemoryFunctions = ({
  show,
  handleShowModal,
  handleCloseModal,
  memories,
  handleDelete,
  handleStatus,
  teamId,
  userId,
  team_id,
  user_id,
  getMemories,
  dynamicQRCodeId,
}) => {
  const target = useRef(null);

  const [showCopyPopup, setShowCopyPopup] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [mobileView] = useAtom(mobileViewCheck);

  const handleQrOpen = (obj) => {
    setSelectedData(obj);
    setQrOpen(true);
  };

  const handleQRClose = () => {
    setQrOpen(false);
    setShowCopyPopup(false);
    setSelectedData("");
  };

  const handleShareOpen = (obj) => {
    const searchParams = new URLSearchParams(window.location.search);

    const source = window.location.search.includes("dynamic_qr_code")
      ? "QR Code"
      : window.location.search.includes("team_id") &&
        window.location.search.includes("user_id")
      ? "Team Function"
      : "Function Page";

    const team_id = searchParams.get("team_id");
    const user_id = searchParams.get("user_id");
    const dynamic_qr_code = searchParams.get("dynamic_qr_code");

    trackEvent(`Share Action Initiated from ${source}`, {
      id: obj.id,
      title: obj.title || obj.name,
      function_type: obj.function_type,
      source,
      team_id,
      user_id,
      dynamic_qr_code,
      timestamp: new Date().toISOString(),
    });
    setSelectedData(obj);
    setShareOpen(true);
  };

  const handleShareClose = () => {
    setShareOpen(false);
    setShowCopyPopup(false);
    setSelectedData("");
  };

  const handleDownload = () => {
    html2canvas(document.querySelector("#qr-code")).then(function (canvas) {
      const link = document.createElement("a");
      link.download = "qrcode.png";
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark"
  );

  const columns = [
    {
      name: "Image",
      width: "10%",
      cell: (row) => (
        <div className="titleWrapper">
          <div className="urliconWrapper">
            <img src={urlicon} alt="" />
          </div>
        </div>
      ),
    },
    {
      name: "Title",
      cell: (row) => <p className="globalTitle">{row.title}</p>,
    },
    {
      name: "Memory Type",
      cell: (row) => (
        <p className="globalTitle">
          {row.media_type.charAt(0).toUpperCase() + row.media_type.slice(1)}
        </p>
      ),
    },
    {
      name: "Memory Count",
      cell: (row) => <p className="globalTitle">{row.medias_count}</p>,
    },
    {
      name: "Status",
      width: "10%",
      center: "true",
      cell: (row) =>
        row.is_expired === 1 ? (
          <Form.Check
            type="switch"
            checked={row.status}
            onClick={() =>
              handleStatus(row.id, row.qrCodeCustomize?.function_type)
            }
            disabled
          />
        ) : (
          <Form.Check
            type="switch"
            checked={row.status}
            onClick={() =>
              handleStatus(row.id, row.qrCodeCustomize?.function_type)
            }
          />
        ),
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className="action">
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          {row.is_expired === 1 ? (
            <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
              <li>
                <span
                  className="dropdown-item"
                  to="#"
                  // style={{ color: "var(--error_color)", cursor: "pointer" }}
                  onClick={() => handleDelete(row.id)}
                ><img src={Delete} />
                  Delete
                </span>
              </li>
            </ul>
          ) : (
            <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
              <li>
                {/* <a
                  className="dropdown-item"
                  href={row.url_path}
                  target="_blank"
                  rel="noreferrer"
                >
                  Show
                </a> */}
                <Link
                  className="dropdown-item"
                  to={
                    teamId && userId
                      ? `/team/${teamId}/teamMembers/member/${userId}/function/viewMemory/${row.id}`
                      : `/function/viewMemory/${row.id}${
                          team_id && user_id
                            ? `?team_id=${team_id}&user_id=${user_id}`
                            : ""
                        }`
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                   <AiOutlineEye />
                  View
                </Link>
              </li>
              <li>
                <span
                  className="dropdown-item"
               
                  onClick={() => handleShowModal(row)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                     cursor: "pointer"
                  }}
                ><img src={Edit} />
                  Edit
                </span>
              </li>
              <li>
                <span
                  className="dropdown-item"
                  // onClick={() =>
                  //   handleStatus(row.id, row.qrCodeCustomize?.function_type)
                  // }
                  onClick={() => {
                    const newStatus = row.status ? "Inactive" : "Active";

                    trackEvent("Upload Memory Status Changed", {
                      id: row.id,
                      function_type: row.function_type,
                      status: newStatus,
                      previous_status: row.status ? "Active" : "Inactive",
                    });

                    handleStatus(row.id, row.qrCodeCustomize?.function_type);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                > <BsCircleFill />
                  {row.status == true ? "Inactive" : "Active"}
                </span>
              </li>
              {dynamicQRCodeId !== null ? (
                ""
              ) : (
                <>
                  <li>
                    <span
                      className="dropdown-item"
                      onClick={() => handleQrOpen(row)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    ><img src={Qrcode} />
                      QR Code
                    </span>
                  </li>
                  <li>
                    <span
                      className="dropdown-item"
                      onClick={() => handleShareOpen(row)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    ><img src={Share} />
                      Share
                    </span>
                  </li>
                </>
              )}

              <li>
                <span
                  className="dropdown-item"
                  to="#"
                  // style={{ color: "var(--error_color)", cursor: "pointer" }}
                  // onClick={() => handleDelete(row.id)}
                  onClick={() => {
                    trackEvent("Upload Memory Deleted", {
                      id: row.id,
                      function_type: row.function_type,
                    });

                    handleDelete(row.id);
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                ><img src={Delete} />
                  Delete
                </span>
              </li>
            </ul>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="default-list-table">
        <DataTable columns={columns} data={memories} theme="solarized" />
      </div>

      {qrOpen && (
        <QRCodeModal
          qrOpen={qrOpen}
          target={target}
          handleQRClose={handleQRClose}
          setShowCopyPopup={setShowCopyPopup}
          handleDownload={handleDownload}
          functionType="memory"
          functionUuid={selectedData.uuid}
          id={selectedData.id}
          function_type={selectedData.function_type}
          functionId={selectedData.id}
          QRCodeCustomize={selectedData.qrCodeCustomize}
          refreshData={getMemories}
        />
      )}

      {shareOpen && (
        <ShareModal
          target={target}
          shareOpen={shareOpen}
          handleShareClose={handleShareClose}
          setShowCopyPopup={setShowCopyPopup}
          functionType="memory"
          functionUuid={selectedData.uuid}
        />
      )}

      <Overlay
        target={target.current}
        show={showCopyPopup}
        placement={mobileView ? "left" : "right"}
      >
        {(props) => (
          <Tooltip id="overlay-example" {...props}>
            Link Copied
          </Tooltip>
        )}
      </Overlay>
    </>
  );
};

export default ShowMemoryFunctions;
